var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.processor.loading)?_c('div',{staticClass:"spinner-container"},[_c('SpinnerVue',{staticClass:"spinner",attrs:{"id":(_vm.uid + "_spinner"),"variant":_vm.variant}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }